export enum LightningDocsStatus {
  PENDING = 'Pending',
  COMPLETED = 'Completed',
}
